import { $t } from '@/i18n';
import { getDocLink } from '@utils/links';

/* eslint-disable */
__webpack_public_path__ = `${window.GLOBAL_INFO.staticFileCdn || window.GLOBAL_INFO.pathPrefix}/xystatic/`;

window.MagicalWorker = class MagicalWorker extends Worker {
  constructor(url, ...args) {
    if (/^https?:/.test(url)) {
      url = URL.createObjectURL(new Blob(["importScripts(" + JSON.stringify(url) + ")"]));
    }
    super(url, ...args);
  }
};

// micro-app 内嵌场景
if (window.__MICRO_APP_ENVIRONMENT__) {
  const { globalAPI } = window.microApp.getData();
  const {hasBeaconSpace} = window.GLOBAL_INFO;

  const guides = [
    {
      id: "component-hub",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "server",
      // tooltip 内容
      tooltipContent: $t('k_7e3424ab'),
      // 点击事件回调
    },
    {
      id: "layout",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "layers-line",
      // tooltip 内容
      tooltipContent: $t('k_1d3baf61'),
      // 点击事件回调
    },
    {
      id: "global",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "usergroup",
      // tooltip 内容
      tooltipContent: $t('k_b877305'),
      // 点击事件回调
    },
    {
      id: "group",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "app2-line",
      // tooltip 内容
      tooltipContent: $t('k_f96d3365'),
    },
    {
      id: "shop",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "company",
      // tooltip 内容
      tooltipContent: $t('k_98babb0e'),
    },
    {
      id: 'authority',
      icon: 'authority-filled',
      tooltipContent: $t('k_48959f5c')
    }
  ];

  const { HOME } = getDocLink();

  if (HOME) {
    guides.push({
      id: "docs",
      // 引导图表，可以使用基座提供的图标或者 CDN URL
      icon: "doubt-filled",
      // tooltip 内容
      tooltipContent: $t('k_fb51ac48'),
      // 点击事件回调
      onClick: () => window.open(HOME, "_blank"),
    })
  }

  globalAPI.navigation.setTopNavigation({
    enableSearch: false,
    enablePrimaryNavs: true,
    primaryNavs: [
      {
        id: "wuji-srouce",
        activeRule: /wuji-source\//,
        // 导航名称
        title: $t('k_8c20c8e3'),
        // 点击事件回调
        onClick: () => {
          globalAPI.router.subAppReplace("wuji-source", { path: "/p/" });
        },
      },
      {
        id: "wuji",
        activeRule: /\/wuji\/xy/,
        // 导航名称
        title: $t('k_3ecad5e3'),
        // 点击事件回调
        onClick: () => {},
      },
    ],
    guides,
  });
  if (!hasBeaconSpace) {
    globalAPI.navigation.disableSpaceSwitch();
  }
}
